import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Freon Core Interfaces",
description: "Overview of the essential TypeScript interfaces that define Freon’s core editor and model framework: FreNode, FreNamedNode, FreAction, and FreCustomAction.",
tags: [ "Core Interfaces", "FreNode", "FreAction", "Freon", "TypeScript"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};